import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./selectInstitution.module.css";
import logo from "../../../assets/logo-login.svg";

import { useRole } from "../../../context/RoleContext";
import { useInstitution } from "../../../context/InstitutionContext";
import { useMantenedora } from "../../../context/MantenedoraContext";
import { getFavoriteDashboard } from "../../../services/preferences";

const BuildingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 21H21M4 21V8L12 3L20 8V21M9 21V14H15V21M9 8H9.01M15 8H15.01M9 11H9.01M15 11H15.01"
      stroke="#0962AD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SelectInstitution = () => {
  const navigate = useNavigate();
  const { role } = useRole();
  const { setInstitution, firstAccess } = useInstitution();
  const {
    institutions,
    institutionsLoading,
    setSelectedInstitutionId,
    setIndividualView
  } = useMantenedora();

  const [selecting, setSelecting] = useState(false);

  const handleSelect = async (inst) => {
    if (selecting) return;
    setSelecting(true);

    try {
      setSelectedInstitutionId(inst.id);
      setIndividualView(inst.id);
      setInstitution(inst);

      if (role === "MantenedoraAdmin" || role === "MantenedoraManager") {
        navigate(firstAccess ? "/app/instituicoes" : "/app/dashboard", { replace: true });
        return;
      }

      if (firstAccess && role === "Admin") {
        navigate("/app/configuracoes", { replace: true });
        return;
      }

      if (firstAccess || role === "Operator") {
        navigate("/app/importar-dados", { replace: true });
        return;
      }

      if (role === "FinancialPlus" || role === "Financial") {
        navigate("/app/financeiro", { replace: true });
        return;
      }

      if (role === "AcademicPlus" || role === "Academic") {
        navigate("/app/financeiro", { replace: true });
        return;
      }

      if (role === "Manager") {
        try {
          const favId = await getFavoriteDashboard();
          if (favId) {
            navigate(`/app/dashboard-customizado/${favId}`, { replace: true });
            return;
          }
        } catch (_) {}
        navigate("/app/dashboard", { replace: true });
        return;
      }

      try {
        const favId = await getFavoriteDashboard();
        if (favId) {
          navigate(`/app/dashboard-customizado/${favId}`, { replace: true });
          return;
        }
      } catch (_) {}

      navigate("/app/dashboard", { replace: true });
    } catch (err) {
      console.error("Erro ao selecionar instituição:", err);
      setSelecting(false);
    }
  };

  if (institutionsLoading) {
    return (
      <div className={styles.container}>
        <img src={logo} alt="Academetrics" className={styles.logo} />
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <span className={styles.loadingText}>Carregando instituições...</span>
        </div>
      </div>
    );
  }

  if (!institutions || institutions.length === 0) {
    return (
      <div className={styles.container}>
        <img src={logo} alt="Academetrics" className={styles.logo} />
        <p className={styles.empty}>Nenhuma instituição encontrada.</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <img src={logo} alt="Academetrics" className={styles.logo} />
      <p className={styles.title}>Selecione a instituição</p>
      <p className={styles.subtitle}>
        Escolha a instituição que deseja acessar
      </p>

      <div className={styles.grid}>
        {institutions.map((inst) => (
          <div
            key={inst.id}
            className={styles.card}
            onClick={() => handleSelect(inst)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleSelect(inst)}
          >
            <div className={styles.cardIcon}>
              <BuildingIcon />
            </div>
            <div className={styles.cardContent}>
              <span className={styles.cardName}>{inst.name}</span>
              {inst.cnpj && (
                <span className={styles.cardDetail}>{inst.cnpj}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectInstitution;
